import { render } from "./ReportOperationalVehicles.vue?vue&type=template&id=08d8a543"
import script from "./ReportOperationalVehicles.vue?vue&type=script&lang=js"
export * from "./ReportOperationalVehicles.vue?vue&type=script&lang=js"
script.render = render

export default script